import { Global, LineSelectedSchedule, LineSelectedTask } from '../../model';
import { deepmerge } from 'utilities/merge';
const defaultTaskable = {
  klass: '',
  location_id:       { value: '', text: '' },
  locations_person_id: { value: '', text: '' },
  delivery_option_ids: { items: [] },
  who: { value: '' },
  shipfrom: { value: '' }
}
export class NewValuesFormsTasksUpdateTaskable {
  static set(taskable = {}, schedule: LineSelectedSchedule){
    taskable = deepmerge(defaultTaskable, taskable);
    let taskData = schedule.taskData();
    if(taskData.taskable_type && taskData.taskable_id){
      if(taskData.taskable_type == 'Tasks::Casting'){
        this.setCasting(taskable, taskData);
      } else if(taskData.taskable_type == 'Tasks::Delivery') {
        this.setDelivery(taskable, taskData);
      }
    }
    return taskable;
  }
  private static setCasting(taskable, taskData){
    let taskableData = Global.getTaskableData(taskData.taskable_id, taskData.taskable_type)
    taskable['klass'] = taskableData.klass,
    taskable['planned_num'] = {
      value: taskableData.planned_num,
    };
  }
  private static setDelivery(taskable, taskData){
    let taskableData = Global.getTaskableData(taskData.taskable_id, taskData.taskable_type)
    let locationText = ''
    if(taskableData.location_id){
      locationText = Global.getLocationData(taskableData.location_id).name
    }
    let locationsPersonText = ''
    if(taskableData.locations_person_id){
      let tmpData = Global.getLocationsPersonData(taskableData.locations_person_id);
      let name = ''
      if(tmpData){
        name = tmpData.name;
      }
      locationsPersonText = name
    }
    taskable['klass'] = taskableData.klass,
    taskable['location_id'] = {
      value: taskableData.location_id,
      text:  locationText,
      typeahead: {
        params: {
          o: taskData.order_id
        }
      }
    };
    taskable['locations_person_id'] = {
      value: taskableData.locations_person_id,
      text:  locationsPersonText,
    };
    if(taskableData.location_id){
      let newPath = '/locations/' + taskableData.location_id + '/people/typeahead'
      taskable['locations_person_id']['typeahead'] = { get_action: newPath };
    }
    let items = []
    for(let i=0; i<taskableData.delivery_option_ids.length; i++){
        let id = taskableData.delivery_option_ids[i];
        let item = Global.getDeliveryOptionData(id);
        items.push({ id: item.id, text: item.contents })
    }
    taskable['delivery_option_ids'] = {
      items: items
    }
    taskable['who'] = {
      value: taskableData.who
    }
    taskable['shipfrom_id'] = {
      value: taskableData.shipfrom_id
    }
  }
}
